import { styled } from "@acko-tech/building-blocks.ui.common";

export const InfoCard = styled.div`
  border-radius: 16px;
  background: #f3f3ff;
  backdrop-filter: blur(7px);
  padding: 16px;
`;

export const InfoCardMedia = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

export const InfoCardTitle = styled.div`
  color: #0a0a0a;
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  text-align: center;
  padding: 4px 0px 20px;
`;
